import {
  Text,
  TouchableOpacity,
  type TouchableOpacityProps,
} from 'react-native';
import React, { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { isWeb } from '~/utils/device';

interface Props extends TouchableOpacityProps {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}

const Button = ({ variant = 'primary', children, ...rest }: Props) => {
  const containerStyle = useMemo(() => {
    if (variant === 'secondary') {
      return 'border-2 border-light-100 py-[8px] px-[18px]';
    }

    return 'bg-light-100';
  }, [variant]);

  const textStyle = useMemo(() => {
    const fontSizeValidation = ` ${isWeb ? 'text-sm' : 'text-[11px]'}`;

    if (variant === 'secondary') {
      return 'text-light-100' + fontSizeValidation;
    }

    return 'text-credsystem-dark-500' + fontSizeValidation;
  }, [variant]);

  return (
    <TouchableOpacity
      className={twMerge('py-[10px] px-5 mr-2 rounded-md', containerStyle)}
      {...rest}
    >
      <Text
        className={twMerge(
          'text-center font-medium uppercase text-credsystem-dark-500',
          textStyle
        )}
      >
        {children}
      </Text>
    </TouchableOpacity>
  );
};

export default Button;
